import { render, staticRenderFns } from "./ppr.vue?vue&type=template&id=1a589ed8&lang=pug&"
import script from "./ppr.vue?vue&type=script&lang=js&"
export * from "./ppr.vue?vue&type=script&lang=js&"
import style0 from "./ppr.vue?vue&type=style&index=0&id=1a589ed8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports